export function getLoginSupported(signal) {
	return fetch('/zx/login/supported', { signal }).then((res) => {
		if (res.status === 200) return res.json();
		throw Error('Network Error');
	});
}

export function getLoginConfig(version, domain, host) {
	const urlParams = new URLSearchParams();
	if (domain) urlParams.append('domain', domain);
	if (host) urlParams.append('host', host);
	return fetch(`/zx/login/v${version}/config?${urlParams}`, {
		method: 'GET'
	}).then((res) => {
		if (res.status === 200) return res.json();
		throw Error('Network Error');
	});
}
